import { useContext, useEffect, useState } from "react";
import styles from "./Abas.module.css";
import { FormControl, InputLabel, Button } from "@mui/material";
import { WhiteInput } from "../../../../components/Inputs/InputText";
import { BlueHoverButton } from "../../../../components/Inputs/BlueHoverButton";
import servSolicitacaoAcesso from "../../../../services/login/servSolicitacaoAcesso";
import { EquipamentosSearchField } from "../../../../components/Searchfields/Equipamentos";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import stylesCad from "../Cadastro.module.css";
import Popup from "../../../../components/Popup";
import Cadastro from "../../../Equipamentos/Cadastro";
import ListaSelecionarEquipamento from "../../../Equipamentos";
import { EquipamentoContext } from "../../../../contexts/EquipamentoContext";
import { HelperText } from "../../../../components/Errors/HelperText";
import { ListaEquipamento } from "../../../../components/ListaEquipamento/ListaEquipamento";


const Equipamentos = ({
    codigoSolicitacao,
    setIsLoading,
    setOpenError,
    setErrorMessage,
    setTypeAlert,
    setPotenciaInstalada,
    parecerEquipamentos,
    situacaoSolic,
    goEquips,
    setGoEquips,
    onKeyDown
}) => {
    const { control, setValue, getValues, setError, formState: { errors } } = useFormContext();
    const [codigoEquipamento, setCodigoEquipamento] = useState(0);
    const [quantidade, setQuantidade] = useState(0);
    const [rowsWFunction, setRowsWFunction] = useState([]);
    const [equipamentoSelecionadoModal, setEquipamentoSelecionadoModal] = useState(null);

    const [openPopupEquip, setOpenPopupEquip] = useState(false);
    const [openPopupListaEquip, setOpenPopupListaEquip] = useState(false);
    const { codigoEquipamentoCtx, equipamentoCtx, salvarNovoEquipamento } = useContext(EquipamentoContext);

    const potenciaInstaladaWatch = useWatch({control,name: "PotenciaInstalada"});

    const editavel = (
        situacaoSolic === 1 || situacaoSolic === 4 || situacaoSolic === 5 || parecerEquipamentos === 2
            ? false
            : true
    );

    useEffect(() => {
        if (potenciaInstaladaWatch !== undefined && potenciaInstaladaWatch !== null) {
            setPotenciaInstalada(Number(potenciaInstaladaWatch));
        }
    }, [potenciaInstaladaWatch]);

    const handleSubmitEquipamentos = async () => {
        try {
            setIsLoading(true);

            if (!getValues("Id")) {
                setTypeAlert("warning");
                setOpenError(true);
                setErrorMessage("Para adicionar equipamentos, é necessário salvar o orçamento de conexão com informações válidas.");

                setIsLoading(false);
                return;
            }

            if (!codigoEquipamento || codigoEquipamento.value === 0) {
                setTypeAlert("warning");
                setOpenError(true);
                setErrorMessage("O equipamento deve ser informado.");

                setIsLoading(false);
                return;
            }

            if (Number(quantidade) <= 0) {
                setTypeAlert("warning");
                setOpenError(true);
                setErrorMessage("A quantidade deve ser maior que zero.");

                setIsLoading(false);
                return;
            }

            if (!Number.isInteger(Number(quantidade))) {
                setTypeAlert("warning");
                setOpenError(true);
                setErrorMessage("A quantidade deve ser um valor inteiro.");

                setIsLoading(false);
                return;
            }

            const response = await servSolicitacaoAcesso.InserirEquipamentos({
                CodigoEquipamento: codigoEquipamento.value,
                CodigoSolicitacaoAcesso: codigoSolicitacao,
                Quantidade: quantidade
            });

            let novoEquipamentos = response.Content;

            novoEquipamentos.map((equip) => {
                equip.id = equip.Id
            });

            addSetToRowsData(novoEquipamentos);

            setIsLoading(false);

            setCodigoEquipamento({
                value: 0,
                label: 'Equipamento'
            });
            setQuantidade(0);

            salvarNovoEquipamento(null, null);
        } catch (err) {
            setIsLoading(false);

            setOpenError(true);
            setErrorMessage(err.response.data.Message);
        }
    }

    const addSetToRowsData = (novosEquipamentos) => {
        let rowCFuncao = novosEquipamentos;

        const formattedRowsWFunction = rowCFuncao.map(element => {
            return {
                ...element,
                setEquips: setGoEquips,
                setEquipsFunctions: setRowsWFunction
            }
        });

        setGoEquips(novosEquipamentos);
        setRowsWFunction(formattedRowsWFunction);
    }

    const addSetToRows = () => {
        const formattedRowsWFunction = goEquips.map(element => {
            return {
                ...element,
                setEquips: setGoEquips,
                setEquipsFunctions: setRowsWFunction
            };
        });

        setRowsWFunction(formattedRowsWFunction);
    }

    const abrirCadastroEquipamento = () => {
        setOpenPopupEquip(true);
    }

    const abrirListaEquipamento = () => {
        if (editavel) {
            setOpenPopupListaEquip(true);
        }
    }

    const retornaDescricaoNumeroFases = (numeroFases) => {
        let txtNumeroFases = "";

        switch (Number(numeroFases)) {
            case 1:
                txtNumeroFases = "Monofásica"
                break;
            case 2:
                txtNumeroFases = "Bifásica"
                break;
            case 3:
                txtNumeroFases = "Trifásica"
                break;
            default:
                break;
        }

        return txtNumeroFases;
    }

    const handleSelecionarEquipamento = () => {
        if (!equipamentoSelecionadoModal) return;

        const tensaoFornecimento = equipamentoSelecionadoModal?.CodigoTensaoFornecimento ? `| Tensão nominal (V): ${equipamentoSelecionadoModal.CodigoTensaoFornecimento} - ${equipamentoSelecionadoModal.TensaoFornecimento.Descricao}` : '';

        setCodigoEquipamento({
            value: equipamentoSelecionadoModal.id,
            label: `${equipamentoSelecionadoModal.Descricao} (${equipamentoSelecionadoModal.id})`,
            subtitle: `Modelo: ${equipamentoSelecionadoModal.Modelo} | Fases: ${retornaDescricaoNumeroFases(equipamentoSelecionadoModal.NumeroFases)} | Fabricante: ${equipamentoSelecionadoModal.Fabricante} | Potência: ${equipamentoSelecionadoModal.PotenciaKw} kW ${tensaoFornecimento}`
        });

        setOpenPopupListaEquip(false);
        setEquipamentoSelecionadoModal(null);
    }

    useEffect(() => {
        addSetToRows();
    }, [goEquips]);

    useEffect(() => {
        if (!codigoEquipamentoCtx) return;

        const tensaoFornecimento = equipamentoSelecionadoModal?.CodigoTensaoFornecimento ? `| Tensão nominal (V): ${equipamentoSelecionadoModal.CodigoTensaoFornecimento} - ${equipamentoSelecionadoModal.TensaoFornecimento.Descricao}` : '';
        const labelSearch = equipamentoCtx ? equipamentoCtx.descricao + ' - ' + `Modelo: ${equipamentoCtx.modelo} | Fases: ${retornaDescricaoNumeroFases(equipamentoCtx.fases)} | Fabricante: ${equipamentoCtx.fabricante} | Potência: ${equipamentoCtx.potencia} kW (${codigoEquipamentoCtx})` : '';

        setCodigoEquipamento({
            value: codigoEquipamentoCtx,
            label: equipamentoSelecionadoModal ? `${equipamentoSelecionadoModal?.Descricao} (${equipamentoSelecionadoModal?.Id})` : labelSearch,
            subtitle: equipamentoSelecionadoModal ? `Modelo: ${equipamentoSelecionadoModal?.Modelo} | Fases: ${retornaDescricaoNumeroFases(equipamentoSelecionadoModal?.NumeroFases)} | Fabricante: ${equipamentoSelecionadoModal?.Fabricante} | Potência: ${equipamentoSelecionadoModal?.PotenciaKw} kW ${tensaoFornecimento}` : ''
        });
    }, [codigoEquipamentoCtx, equipamentoCtx]);

    return (
        <div>
            <div style={{ padding: "30px 40px 0" }}>
                <FormControl variant="outlined" className={styles['campos-g-aba']} style={{ zIndex: 2 }}>
                    <InputLabel shrink htmlFor="codigoequip-equipamento" sx={{ color: "#b8b8b8" }} >Equipamento</InputLabel>
                    <EquipamentosSearchField
                        id="codigoequip-equipamento"
                        setErrorMessage={setErrorMessage}
                        setOpenError={setOpenError}
                        setValue={setCodigoEquipamento}
                        value={codigoEquipamento}
                        onKeyDown={onKeyDown}
                        handleOpenLista={abrirListaEquipamento}
                        editavel={editavel}
                    />
                </FormControl>
            </div>
            <p className={styles.campoAbrirEquip} onClick={abrirCadastroEquipamento}>Não encontrou o equipamento? Clique aqui e cadastre um novo!</p>
            <div className={styles.containerEquipamentos}>
                <FormControl variant="outlined" className={stylesCad['campos-p']}>
                    <InputLabel shrink htmlFor="quantidade-equipamento" sx={{ color: "#b8b8b8" }} >Quantidade</InputLabel>
                    <WhiteInput
                        fullWidth
                        placeholder="Quantidade"
                        id="codigoequip-quantidade"
                        type="number"
                        name="Quantidade"
                        disabled={!editavel}
                        value={quantidade}
                        onChange={(e) => setQuantidade(e.target.value)}
                        onKeyDown={onKeyDown}
                    />
                </FormControl>

                <BlueHoverButton disabled={!editavel} onClick={handleSubmitEquipamentos}>Adicionar</BlueHoverButton>
            </div>
            <span className={styles.importante_equipamento}>*É importante informar tanto Módulos quanto Inversores!</span>

            <div className={styles.listaEquipamentos}>
                <ListaEquipamento
                    equipamentos={rowsWFunction}
                    setIsLoading={setIsLoading}
                />
            </div>

            <Popup title="Equipamentos" openPopup={openPopupEquip} setOpenPopup={setOpenPopupEquip}>
                <Cadastro
                    setOpenPopup={setOpenPopupEquip}
                    recordForEdit={null}
                    origemSolicitacao={true}
                />
            </Popup>
            <Popup
                title="Selecionar equipamento"
                openPopup={openPopupListaEquip}
                setOpenPopup={setOpenPopupListaEquip}
                minWidth="900px"
                actions={[
                    <Button onClick={() => setOpenPopupListaEquip(false)}>Fechar</Button>,
                    <Button onClick={handleSelecionarEquipamento}>Selecionar</Button>
                ]}>
                <ListaSelecionarEquipamento
                    popupLista={true}
                    setSelectedData={(e) => {
                        if (!e) return;

                        setEquipamentoSelecionadoModal(e)
                    }}
                    onDblClick={handleSelecionarEquipamento}
                />
            </Popup>
            <div style={{ padding: "30px 40px 0" }} /*className={styles.containerParticipantes}*/>
                <Controller
                    name="PotenciaInstalada"
                    control={control}
                    render={({ field }) => (
                        <FormControl variant="outlined" className={styles['campos-m']}>
                            <InputLabel htmlFor="solicitacao-DisjustorUc" shrink sx={{ color: "#B8B8B8" }} >Potência instalada</InputLabel>
                            <WhiteInput
                                fullWidth placeholder="Potência" id="solicitacao-PotenciaInstalada"
                                name="PotenciaInstalada" {...field} readOnly={!editavel} type="number"
                                className={`${errors?.PotenciaInstalada ? styles.campoComValorErrado : ""}`}
                                onBlur={(e) => {
                                    var messagePotenciaInstalada = '';

                                    if (e.target.value <= 0 || !e.target.value.trim())
                                        messagePotenciaInstalada = "O valor deve ser maior que zero.";

                                    if (messagePotenciaInstalada) {
                                        setError("PotenciaInstalada", {
                                            message: messagePotenciaInstalada,
                                        });
                                    }
                                }}
                            />
                            {errors?.PotenciaInstalada && (
                                <HelperText text={errors?.PotenciaInstalada?.message} />
                            )}
                        </FormControl>
                    )}
                />
            </div>
        </div>
    )
}

export { Equipamentos }